import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';

import { IFastFiltersUserResponseSchema } from '../../repositories/monolith-python/entities/schemas/FastFiltersUserResponseSchema';
import {
  fetchCianApiSiteV1GetUserDataByRequest,
  TCianApiSiteV1GetUserDataByRequestResponse,
} from '../../repositories/monolith-python/cian-api/site/v1/get-user-data-by-request';

interface IDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
  subdomain: string;
}

export async function resolveUser({
  httpApi,
  logger,
  subdomain,
}: IDependencies): Promise<IFastFiltersUserResponseSchema> {
  try {
    const result: TCianApiSiteV1GetUserDataByRequestResponse = await fetchCianApiSiteV1GetUserDataByRequest({
      httpApi,
      config: {
        subdomain,
      },
    });

    return result.response.data;
  } catch (error) {
    logger.error(error, {
      comment: '[Degradation] Нет информации о пользователе, пользователь считается неавторизованным',
    });

    return {};
  }
}
